import { BuzzerState, Comparator, GuardZoneState, PumpState, RadioSensorValue, RelayControlState, Sensor433State, SensorState, ThreewayTapState, } from 'z3k-config';
export const sensorStateTranslate = {
    [SensorState.OFFLINE]: 'Потеря связи',
    [SensorState.OUT_OF_UPPER_THRESHOLD]: 'Выход за верхний порог',
    [SensorState.OUT_OF_LOWER_THRESHOLD]: 'Выход за нижний порог',
    [SensorState.ACTUATION]: 'Срабатывание',
    [SensorState.RECOVERY]: 'Восстановление',
    [SensorState.OUT_OF_UPPER_HUMIDITY_THRESHOLD]: 'Выход за верхний порог влажности',
    [SensorState.OUT_OF_LOWER_HUMIDITY_THRESHOLD]: 'Выход за нижний порог влажности',
};
export const pumpStateTranslate = {
    [PumpState.ON]: 'Включена',
    [PumpState.OFF]: 'Выключена',
};
export const relayControlStateTranslate = {
    [RelayControlState.ON]: 'Включено',
    [RelayControlState.OFF]: 'Выключено',
};
export const guardZoneStateTranslate = {
    [GuardZoneState.GUARD_ON]: 'На охране',
    [GuardZoneState.GUARD_OFF]: 'Снята с охраны',
    [GuardZoneState.ALARM]: 'Сработала',
};
export const buzzerStateTranslate = {
    [BuzzerState.ON]: 'Включена',
    [BuzzerState.OFF]: 'Выключена',
};
export const threewayTapStateTranslate = {
    [ThreewayTapState.AT_REST]: 'В покое',
    [ThreewayTapState.OPENING]: 'Открывается',
    [ThreewayTapState.CLOSING]: 'Закрывается',
    [ThreewayTapState.OPEN]: 'Открыт',
    [ThreewayTapState.CLOSE]: 'Закрыт',
};
export var CommandArgument;
(function (CommandArgument) {
    CommandArgument[CommandArgument["OFF"] = 0] = "OFF";
    CommandArgument[CommandArgument["ON"] = 1] = "ON";
})(CommandArgument || (CommandArgument = {}));
export const commandReactionTranslate = {
    [CommandArgument.OFF]: 'Выключить',
    [CommandArgument.ON]: 'Включить',
};
export var ThreewayTapArgument;
(function (ThreewayTapArgument) {
    ThreewayTapArgument[ThreewayTapArgument["OPEN"] = 1] = "OPEN";
    ThreewayTapArgument[ThreewayTapArgument["CLOSE"] = 2] = "CLOSE";
})(ThreewayTapArgument || (ThreewayTapArgument = {}));
export const threewayTapReactionTranslate = {
    [ThreewayTapArgument.OPEN]: 'Открыть',
    [ThreewayTapArgument.CLOSE]: 'Закрыть',
};
export var SetGuardArgument;
(function (SetGuardArgument) {
    SetGuardArgument[SetGuardArgument["GUARD_OFF"] = 0] = "GUARD_OFF";
    SetGuardArgument[SetGuardArgument["GUARD_ON"] = 1] = "GUARD_ON";
    SetGuardArgument[SetGuardArgument["INVERT"] = 2] = "INVERT";
})(SetGuardArgument || (SetGuardArgument = {}));
export const setGuardReactionTranslate = {
    [SetGuardArgument.GUARD_OFF]: 'Снять с охраны',
    [SetGuardArgument.GUARD_ON]: 'Поставить на охрану',
    [SetGuardArgument.INVERT]: 'Инвертировать состояние',
};
export const sensor433StateTranslate = {
    [Sensor433State.OFFLINE]: 'Потеря связи',
    [Sensor433State.TRIGGERED]: 'Сработка',
};
export const radioSensorValueTranslate = {
    [RadioSensorValue.TEMPERATURE]: 'температуры',
    [RadioSensorValue.HUMIDITY]: 'влажности',
    [RadioSensorValue.BATTERY_LEVEL]: 'уровня батарейки',
    [RadioSensorValue.RSSI]: 'уровня сигнала',
};
export var TimeUnit;
(function (TimeUnit) {
    TimeUnit[TimeUnit["SEC"] = 1] = "SEC";
    TimeUnit[TimeUnit["MIN"] = 2] = "MIN";
    TimeUnit[TimeUnit["HOUR"] = 3] = "HOUR";
    TimeUnit[TimeUnit["DAY"] = 4] = "DAY";
})(TimeUnit || (TimeUnit = {}));
export const timeUnitTranslate = {
    [TimeUnit.SEC]: 'сек',
    [TimeUnit.MIN]: 'мин',
    [TimeUnit.HOUR]: 'час',
    [TimeUnit.DAY]: 'сутки',
};
export const comparatorTypeTranslate = {
    [Comparator.Type.LESS]: '<',
    [Comparator.Type.MORE]: '>',
    [Comparator.Type.EQUAL]: '=',
    [Comparator.Type.LESS_OR_EQUAL]: '<=',
    [Comparator.Type.MORE_OR_EQUAL]: '>=',
};
